export const LANDSCAPE_ALERT_TITLE = 'Attention!';
export const LANDSCAPE_ALERT_CONTENT = `Screen resolution not vertical.
Kindly open the website in Mobile devices to avail the best experience. 
Do you still want to continue with this screen resolution ?`;
export const OUT_OF_WARRANTY = 'Out of Warranty';
